const calculator = {
    en: {
        "calculator.title": "Calculator",
        "calculator.priceByPort": "Price By Port",

        // table headers / card fields
        "calculator.auction": "Auction",
        "calculator.city": "City",
        "calculator.destination": "Destination",
        "calculator.landPrice": "Land Price",
        "calculator.containerPrice": "Container Price",
        "calculator.total": "Total",
        "calculator.port": "Port",

        // update price modal
        "calculator.updatePrice": "Update Price",
        "calculator.amount": "Amount",
        "calculator.type": "Type",
        "calculator.selectType": "Select Type",
        "calculator.land": "Land",
        "calculator.container": "Container",
        "calculator.action": "Action",
        "calculator.selectAction": "Select Action",
        "calculator.plus": "Plus",
        "calculator.minus": "Minus",

        // remove modal
        "calculator.removeLocation": "Remove calculator location",
        "calculator.confirmRemove": "Do you want to remove?",

        // add / edit city
        "calculator.editTitle": "Edit Location",
        "calculator.addTitle": "Add New Location",
        "calculator.selectAuction": "Select Auction",
        "calculator.enterCity": "Enter city",
        "calculator.enterDestination": "Enter destination",
        "calculator.enterLandPrice": "Enter land price",
        "calculator.enterContainerPrice": "Enter container price",
        "calculator.totalPrice": "Total Price",
        "calculator.enterTotalPrice": "Enter total price",

        // port options
        "calculator.portWA": "Port of WA Washington",
        "calculator.portCA": "Port of CA California",
        "calculator.portTX": "Port of TX Texas",
        "calculator.portGA": "Port of GA Georgia",
        "calculator.portSE": "Port of SE Seatle",
        "calculator.portNJ": "Port of NJ New Jersey",
    },
    ru: {
        "calculator.title": "Калькулятор",
        "calculator.priceByPort": "Цена по порту",

        "calculator.auction": "Аукцион",
        "calculator.city": "Город",
        "calculator.destination": "Назначение",
        "calculator.landPrice": "Цена по суше",
        "calculator.containerPrice": "Цена контейнера",
        "calculator.total": "Итого",
        "calculator.port": "Порт",

        "calculator.updatePrice": "Обновить цену",
        "calculator.amount": "Сумма",
        "calculator.type": "Тип",
        "calculator.selectType": "Выберите тип",
        "calculator.land": "Суша",
        "calculator.container": "Контейнер",
        "calculator.action": "Действие",
        "calculator.selectAction": "Выберите действие",
        "calculator.plus": "Плюс",
        "calculator.minus": "Минус",

        "calculator.removeLocation": "Удалить локацию",
        "calculator.confirmRemove": "Вы хотите удалить?",

        "calculator.editTitle": "Редактировать локацию",
        "calculator.addTitle": "Добавить новую локацию",
        "calculator.selectAuction": "Выберите аукцион",
        "calculator.enterCity": "Введите город",
        "calculator.enterDestination": "Введите назначение",
        "calculator.enterLandPrice": "Введите цену по суше",
        "calculator.enterContainerPrice": "Введите цену контейнера",
        "calculator.totalPrice": "Общая цена",
        "calculator.enterTotalPrice": "Введите общую цену",

        "calculator.portWA": "Порт WA Вашингтон",
        "calculator.portCA": "Порт CA Калифорния",
        "calculator.portTX": "Порт TX Техас",
        "calculator.portGA": "Порт GA Джорджия",
        "calculator.portSE": "Порт SE Сиэтл",
        "calculator.portNJ": "Порт NJ Нью-Джерси",
    },
    geo: {
        "calculator.title": "კალკულატორი",
        "calculator.priceByPort": "ფასი პორტის მიხედვით",

        "calculator.auction": "აუქციონი",
        "calculator.city": "ქალაქი",
        "calculator.destination": "დანიშნულება",
        "calculator.landPrice": "ხმელეთის ფასი",
        "calculator.containerPrice": "კონტეინერის ფასი",
        "calculator.total": "ჯამი",
        "calculator.port": "პორტი",

        "calculator.updatePrice": "ფასის განახლება",
        "calculator.amount": "თანხა",
        "calculator.type": "ტიპი",
        "calculator.selectType": "აირჩიეთ ტიპი",
        "calculator.land": "ხმელეთი",
        "calculator.container": "კონტეინერი",
        "calculator.action": "მოქმედება",
        "calculator.selectAction": "აირჩიეთ მოქმედება",
        "calculator.plus": "მიმატება",
        "calculator.minus": "გამოკლება",

        "calculator.removeLocation": "ლოკაციის წაშლა",
        "calculator.confirmRemove": "გსურთ წაშლა?",

        "calculator.editTitle": "ლოკაციის რედაქტირება",
        "calculator.addTitle": "ახალი ლოკაციის დამატება",
        "calculator.selectAuction": "აირჩიეთ აუქციონი",
        "calculator.enterCity": "შეიყვანეთ ქალაქი",
        "calculator.enterDestination": "შეიყვანეთ დანიშნულება",
        "calculator.enterLandPrice": "შეიყვანეთ ხმელეთის ფასი",
        "calculator.enterContainerPrice": "შეიყვანეთ კონტეინერის ფასი",
        "calculator.totalPrice": "ჯამური ფასი",
        "calculator.enterTotalPrice": "შეიყვანეთ ჯამური ფასი",

        "calculator.portWA": "პორტი WA ვაშინგტონი",
        "calculator.portCA": "პორტი CA კალიფორნია",
        "calculator.portTX": "პორტი TX ტეხასი",
        "calculator.portGA": "პორტი GA ჯორჯია",
        "calculator.portSE": "პორტი SE სიეტლი",
        "calculator.portNJ": "პორტი NJ ნიუ ჯერსი",
    },
};

export default calculator;
